import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';

import css from './SectionPracticalities.module.css';

const iconBase = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

const ICONS = {
  opening_hours: (
    <svg {...iconBase}>
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 15 14" />
    </svg>
  ),
  wifi_speed: (
    <svg {...iconBase}>
      <path d="M5 12.55a11 11 0 0 1 14 0" />
      <path d="M2 8.82a16 16 0 0 1 20 0" />
      <path d="M8.5 16.43a6 6 0 0 1 7 0" />
      <line x1="12" y1="20" x2="12.01" y2="20" />
    </svg>
  ),
  access_type: (
    <svg {...iconBase}>
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  transit: (
    <svg {...iconBase}>
      <rect x="4" y="3" width="16" height="16" rx="2" />
      <line x1="4" y1="11" x2="20" y2="11" />
      <circle cx="8.5" cy="15.5" r="1" />
      <circle cx="15.5" cy="15.5" r="1" />
    </svg>
  ),
  parking_available: (
    <svg {...iconBase}>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M10 17V8h3.5a2.5 2.5 0 0 1 0 5H10" />
    </svg>
  ),
};

const KEYS = ['opening_hours', 'wifi_speed', 'access_type', 'transit', 'parking_available'];

const formatValue = (key, value) => {
  if (typeof value === 'boolean') {
    return value ? '✓' : '–';
  }
  return value;
};

/**
 * Renders icon+label+value rows for known cowork practicality fields.
 *
 * Props:
 *   - publicData
 */
const SectionPracticalities = props => {
  const { publicData } = props;

  if (!publicData) return null;

  const rows = KEYS.filter(k => {
    const v = publicData[k];
    return v !== undefined && v !== null && v !== '';
  });

  if (rows.length === 0) return null;

  return (
    <section className={css.root}>
      <Heading as="h2" rootClassName={css.heading}>
        <FormattedMessage id="ListingPage.practicalitiesTitle" />
      </Heading>
      <ul className={css.list}>
        {rows.map(k => (
          <li key={k} className={css.row}>
            <span className={css.iconWrap}>{ICONS[k]}</span>
            <span className={css.label}>
              <FormattedMessage id={`ListingPage.practicality.${k}`} />
            </span>
            <span className={css.value}>{formatValue(k, publicData[k])}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default SectionPracticalities;
